import { useEffect, useState } from 'react';

/**
 * Custom hook to handle window resize and update state based on width
 * @returns boolean indicating if the window is in "desktop" mode (width >= 900px)
 */
export const useResponsive = () => {
    const [isDesktop, setIsDesktop] = useState<boolean>(window.innerWidth > DESKTOP);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > DESKTOP);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isDesktop };
};

/**
 * Responsive breakpoint (px)
 */
const DESKTOP = 900;
